import Vue from 'vue'
import Grid from 'vue-js-grid'

Vue.use(Grid)
